import { takeLatest, put, call, fork } from "redux-saga/effects";
import { AuthService } from "services";
import {
    fetchedUser,
    failedFetchUser,
    fetchedUserPermissions,
    failedFetchUserPermissions
} from "actions";
import { USER_ACTIONS } from "constants";

function* userProfileHandler() {
    const { data, error } = yield call(AuthService.getUser);
    if (!error) {
        let newData = {
            ...data,
            stage_permissions: [
                // {
                //     id: 0,
                //     ids: data.stage_permissions.map(_ => _.id),
                //     stage_name: "My Cases",
                //     columns: MY_INBOX_COLS
                // },
                ...data.stage_permissions
            ]
        };
        yield put(fetchedUser(newData));
    } else {
        yield put(failedFetchUser(error));
    }
}

function* userPermissionsHandler() {
    const { data, error } = yield call(AuthService.getUserPermissions);
    if (!error) {
        yield put(fetchedUserPermissions(data));
    } else {
        yield put(failedFetchUserPermissions(error));
    }
}

export default fork(function*() {
    yield takeLatest(USER_ACTIONS.FETCH_USER, userProfileHandler);
    yield takeLatest(
        USER_ACTIONS.FETCH_USER_PERMISSIONS,
        userPermissionsHandler
    );
});
